module.exports = __webpack_public_path__ + "cancellara-dist/img/up-day.5a4d6de0.png";